import { ExternalLinkIcon } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import { Button } from "@/shared/ui/button";
import { Text, SubText } from "@/shared/ui/typography";
import { T } from "@/shared/i18n";
import { getUrlHost, withHttpProtocol } from "@/shared/lib/is-safe-url";
import { useExternalLinkDialogStore } from "@/shared/lib/external-link-dialog";

// The app-wide confirmation shown before a link takes the user off the platform.
// Mounted once in the root route and driven by openExternalLinkDialog, so no
// surface has to carry a dialog of its own to warn about a link.
export const ExternalLinkDialog = () => {
  const { url, closeExternalLinkDialog } = useExternalLinkDialogStore();

  const handleConfirm = () => {
    if (url) {
      window.open(withHttpProtocol(url), "_blank", "noopener,noreferrer");
    }
    closeExternalLinkDialog();
  };

  return (
    <Dialog
      open={url !== null}
      onOpenChange={(open) => !open && closeExternalLinkDialog()}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            <T id="Open an external website" />
          </DialogTitle>
          <DialogDescription>
            <T id="This link leads to a website outside the platform and opens in a new tab." />
          </DialogDescription>
        </DialogHeader>

        {/* The destination spelled out, host first: what the user is agreeing to. */}
        <div className="rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2">
          <Text className="truncate font-medium text-neutral-900">
            {url && getUrlHost(url)}
          </Text>
          <SubText className="break-all text-neutral-600">{url}</SubText>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={closeExternalLinkDialog}>
            <T id="Cancel" />
          </Button>
          <Button onClick={handleConfirm}>
            <ExternalLinkIcon className="size-4" />
            <T id="Open link" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
